module.exports = __webpack_public_path__ + "Icono_Cerrar2_126px.png";